"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refundUserExpressRules = exports.postRules = exports.objTitlePoints = exports.objTitle = exports.defaultReplyValue = exports.defaultObjAttrValue = exports.defaultObj = void 0;
var _toolsValidate = require("@/utils/toolsValidate");
var postRules = exports.postRules = {
  expressCode: [{
    required: true,
    message: '请选择快递公司',
    trigger: 'change'
  }],
  expressNumber: [{
    required: true,
    message: '请输入快递单号',
    trigger: 'blur'
  }],
  deliveryCarrier: [{
    required: true,
    message: '请输入配送人员',
    trigger: 'blur'
  }],
  carrierPhone: [{
    required: true,
    validator: _toolsValidate.validatePhone,
    trigger: 'blur'
  }],
  isSplit: [{
    required: true,
    message: '请选择分单发货',
    trigger: 'change'
  }]
};
var refundUserExpressRules = exports.refundUserExpressRules = {
  expressName: [{
    required: true,
    message: '请填写物流公司',
    trigger: 'change'
  }],
  trackingNumber: [{
    required: true,
    message: '请填写物流单号',
    trigger: 'change'
  }],
  telephone: [{
    required: true,
    message: '请填写联系电话',
    trigger: 'change'
  }]
};

//普通商品规格默认数据
var objTitle = exports.objTitle = {
  price: {
    title: '售价'
  },
  vipPrice: {
    title: '会员价'
  },
  cost: {
    title: '成本价'
  },
  otPrice: {
    title: '划线价'
  },
  stock: {
    title: '库存'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  },
  brokerage: {
    title: '一级返佣(%)'
  },
  brokerageTwo: {
    title: '二级返佣(%)'
  },
  barCode: {
    title: '商品编码'
  }
};
//积分商品规格默认数据
var objTitlePoints = exports.objTitlePoints = {
  price: {
    title: '兑换金额（元）'
  },
  redeemIntegral: {
    title: '兑换积分'
  },
  cost: {
    title: '成本价（元）'
  },
  otPrice: {
    title: '划线价（元）'
  },
  stock: {
    title: '库存'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  },
  barCode: {
    title: '商品编码'
  }
};

// 积分商城默认规格数据
var defaultObjAttrValue = exports.defaultObjAttrValue = {
  image: '',
  price: 0.0,
  redeemIntegral: 1,
  cost: 0.0,
  stock: 0,
  barCode: '',
  weight: 0,
  volume: 0
};
var defaultReplyValue = exports.defaultReplyValue = {
  nickname: '',
  avatar: '',
  replyDate: '',
  star: 5,
  comment: '',
  pics: []
};
var defaultObj = exports.defaultObj = {
  cateIds: [],
  categoryId: '',
  image: '',
  sliderImages: [],
  sliderImage: '',
  name: '',
  intro: '',
  keyword: '',
  unitName: '',
  sort: 0,
  virtualStock: 0,
  virtualExchangeNum: 1,
  platformHotSell: 1,
  exchangeNum: 0,
  //兑换数量
  isShow: false,
  header: [],
  attrValueList: [{
    image: '',
    price: 0.0,
    vipPrice: 0.0,
    redeemIntegral: 1,
    cost: 0.0,
    otPrice: 0.0,
    stock: 0,
    weight: 0,
    volume: 0,
    barCode: '',
    isShow: true
  }],
  attrList: [],
  attrs: [],
  content: '',
  specType: false,
  id: undefined,
  replyInfo: {
    replyList: [],
    commentsNum: 0,
    ratingRate: 90
  },
  merchantAddressId: ''
};